<template>
  <div class="signContainer">
    <div class="signoHeader">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/personal/sign/home' }"
            >签约管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>发起签约</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <!-- <div class="authentication normalColor ft12">
        您还未进行实名认证！
        <span class="authBtn cursorPointer" @click="goAuth">去认证</span>
      </div>-->
      <div class="contract">
        <div class="title">合同文件</div>
        <span class="OperationGuide" @click="startGuideFn">操作引导</span>
        <slide
          class="slideCustomer"
          @deleteContract="deleteContract"
          @reNameContract="reNameContract"
          :fqTemplateList="fqTemplateList"
          ref="slide"
        >
          <!-- <div class="swiperSlidecustomerAdd" slot="other" @click="toModelContract">
            <div>
              <div class="content slectHeight">
                <img src="@image/personalSign/contract_template_icon.png">
                <p class="selectDscp">选择合同模版</p>
              </div>
            </div>
          </div> -->
        </slide>
        <!-- <div class="signAnnex">
          <div class="annexTitle">
            <div style="margin-top:-17px;">添加附件</div>
          </div>
          <annex ref="annex" style="flex=1" :fileList="annexFileList" :showType="'upload'"></annex>
        </div>-->

        <el-form
          v-show="signPersonList.length"
          ref="contarctOwner"
          :model="contarctOwner"
          :rules="contarctOwnerRule"
          label-width="120px"
          class="contarctOwner"
          size="mini"
        >
          <!-- <el-form-item label="合同类型：" class="nameContract" prop="name">
            <el-radio-group v-model="contarctOwner.isOwner" fill="E88078" @change="isOwnerChange">
              <el-radio label="1">本人合同</el-radio>
              <el-radio label="2">授权合同</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!-- <el-form-item label="授权人：" prop="powerId" v-if="contarctOwner.isOwner == 2">
            <el-select v-model="contarctOwner.powerId" @change="powerIdChange" placeholder="请选择">
              <el-option
                v-for="item in signPersonList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>-->
        </el-form>
      </div>
    </div>
    <div class="paddingBox"></div>
    <div class="signContent">
      <div class="stepDscp sign_form">添加合同信息</div>
      <sign-form
        ref="forms"
        @paymentType="paymentType"
        :data="detail.info"
      ></sign-form>
    </div>
    <div class="paddingBox"></div>
    <div class="signContent">
      <div class="stepDscp information">添加借款信息</div>
      <information
        ref="inforform"
        :fqTemplateList="fqTemplateList"
        :fileVariableInfo="fileVariableInfo"
      ></information>
    </div>
    <div class="paddingBox"></div>
    <div class="signContent">
      <div class="stepDscp">添加合同签署方</div>
      <sort-table
        ref="table"
        :powerId="contarctOwner.powerId"
        @delete="deleteTableItem"
        @addOtherSignPerson="addOtherSignPerson"
      ></sort-table>
      <div class="routeChangeBox">
        <div class="routeChangeButton cursorPointer" @click="toIndex">放弃</div>
        <div
          class="routeChangeButton cursorPointer"
          :disabled="isSubmiting"
          @click="handlerNext"
        >
          提交
        </div>
      </div>
    </div>
    <Dialog
      :visible="authDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      @closeDialog="closeDialog('authDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>您还没有通过实名认证，</p>
          <p>无法发起签约，请去实名认证！</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center">
          <!-- <div class="button cursorPointer" @click="closeDialog('authDialogShow')">取消</div> -->
          <div class="button buttonActive cursorPointer" @click="goAuth">
            去认证
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="noPowerDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      @closeDialog="closeDialog('noPowerDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>你的授权已经被取消，如果想继续发起此授权合同，请联系授权人</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center">
          <div class="button buttonActive cursorPointer" @click="goList">
            确定
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="isOverFreeContract"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      class="mealBox"
    >
      <div class="signDialog" slot="dialog">
        <div class="mealTop">
          <p>您尚有{{ noPayContractConout }}个未支付的合同，不能再新建合同。</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center">
          <div class="button buttonActive cursorPointer" @click="goList">
            确定
          </div>
        </div>
      </div>
    </Dialog>
    <div class="returnPay" v-html="returnPay"></div>

    <div class="guideBoxo" v-if="startGuide">
      <div class="fristSetp" v-show="stepSQ == 1">
        <div class="fristSetpCon">
          <img
            class="fristSetpImg"
            src="../../../assets/images/personalSign/fq_step1.png"
            style="width: 163px"
          />
          <div class="fristSetpBox">
            <div>
              <img
                class="signHome_j"
                src="../../../assets/images/personalSign/connecting_line.png"
              />

              <div class="guodance_sign_bg">
                <div class="title">
                  <h3>合同模板已预置好</h3>
                  <div class="jumpOutFn" @click="jumpOutFn">
                    我已了解 <i class="el-icon-close"></i>
                  </div>
                </div>
                <div class="text_list">
                  <b></b>
                  <p style="padding-left: 12px">
                    如果需要发起其他合同，请与公证处联系
                  </p>
                </div>
                <div class="guodance_sign_bottom">
                  <p>（1 / 3）</p>
                  <button type="button" @click="secondStepSQFn">下一步</button>
                </div>
              </div>
              <!-- <img
                src="../../../assets/images/personalSign/next_nor_btn.png"
                @click="secondStepSQFn"
              >
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn"> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="secondSetp" v-show="stepSQ==2">
        <div class="thirdStepBoxCon">
          <div class="thirdStepBox">
            <img src="../../../assets/images/personalSign/htlx_img.png" />
          </div>
          <div class="fristSetpBox">
            <div>
              <img
                src="../../../assets/images/personalSign/next_nor_btn.png"
                @click="secondStepSQFn"
              />
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn" />
            </div>
          </div>
        </div>
      </div> -->
      <div class="thirdStep" v-show="stepSQ == 2">
        <div class="thirdStepBoxCon">
          <div class="thirdStepBox">
            <img
              class="thirdStepBoxImg"
              style="width: 557px; height: 241px"
              src="../../../assets/images/personalSign/fq_step2.png"
            />
            <div class="fristSetpBox">
              <div>
                <img
                  class="signHome_j"
                  src="../../../assets/images/personalSign/connecting_line.png"
                />
                <div class="guodance_sign_bg">
                  <div class="title">
                    <h3>为合同签署设置参数</h3>
                    <div class="jumpOutFn" @click="jumpOutFn">
                      我已了解 <i class="el-icon-close"></i>
                    </div>
                  </div>
                  <div class="text_list">
                    <b></b>
                    <p style="padding-left: 12px">
                      在 “合同有效期” ，录入约定的有效期
                    </p>
                  </div>
                  <div class="text_list">
                    <b></b>
                    <p style="padding-left: 12px">
                      在 “签约截至日期” 设置最晚签署期限，超过此期限则本合同作废
                    </p>
                  </div>
                  <div class="guodance_sign_bottom">
                    <p>（2 / 3）</p>
                    <button type="button" @click="thirdStepSQFn">下一步</button>
                  </div>
                </div>
                <!-- <img
                  src="../../../assets/images/personalSign/next_nor_btn.png"
                  @click="thirdStepSQFn"
                >
                <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn"> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fourStep1" v-show="stepSQ == 3">
        <div class="thirdStepBoxCon1">
          <div class="thirdStepBox">
            <img
              class="fourStepImg"
              src="../../../assets/images/personalSign/fq_step3.png"
            />
          </div>
          <div class="fristSetpBox">
            <div>
              <img
                class="signHome_j"
                src="../../../assets/images/personalSign/connecting_line.png"
              />
              <div class="guodance_sign_bg">
                <div class="title">
                  <h3>录入合同信息</h3>
                  <div class="jumpOutFn" @click="jumpOutFn">
                    我已了解 <i class="el-icon-close"></i>
                  </div>
                </div>
                <div class="text_list">
                  <b></b>
                  <p style="padding-left: 12px">
                    赋强公证需要以下信息，请正确填写
                  </p>
                </div>
                <div class="guodance_sign_bottom">
                  <p>（3 / 3）</p>
                  <button type="button" @click="jumpOutFn">我知道了</button>
                </div>
              </div>
              <!-- <img src="../../../assets/images/personalSign/next_nor_btn.png" @click="fourStepSQFn">
              <img src="../../../assets/images/personalSign/tg_nor_btn.png" @click="jumpOutFn"> -->
            </div>
          </div>
        </div>
      </div>
      <div class="fiveStep" v-show="stepSQ == 5">
        <div class="thirdStepBoxCon">
          <div class="fristSetpBox">
            <div>
              <img
                src="../../../assets/images/personalSign/kown_nor_btn.png"
                @click="jumpOutFn"
              />
            </div>
          </div>
          <div class="thirdStepBox">
            <div class="fiveTableBob">
              <sort-table
                :powerId="contarctOwner.powerId"
                @delete="deleteTableItem"
                @addOtherSignPerson="addOtherSignPerson"
                :data="detail.signatoryList"
                :paymentTypeVlaue="paymentTypeVlaue"
                class="tableSign"
              ></sort-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="guideBoxn" v-if="startGuiden">
      <div class="fristSetp" v-show="step == 1">
        <div class="fristSetpCon">
          <img
            class="fristSetpImg"
            src="../../../assets/images/personalSign/scbdwj_img.png"
          />
          <div class="fristSetpBox">
            <div>
              <img
                src="../../../assets/images/personalSign/next_nor_btn.png"
                @click="firstStepFn"
              />
              <img
                src="../../../assets/images/personalSign/tg_nor_btn.png"
                @click="jumpOutFn"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="thirdStep" v-show="step == 2">
        <div class="thirdStepBoxCon">
          <div class="thirdStepBox">
            <img src="../../../assets/images/personalSign/htx_img.png" />
          </div>
          <div class="fristSetpBox">
            <div>
              <img
                src="../../../assets/images/personalSign/next_nor_btn.png"
                @click="secondStepFn"
              />
              <img
                src="../../../assets/images/personalSign/tg_nor_btn.png"
                @click="jumpOutFn"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="fourStep" v-show="step == 3">
        <div class="thirdStepBoxCon">
          <div class="fristSetpBox">
            <div>
              <img
                src="../../../assets/images/personalSign/next_nor_btn.png"
                @click="thirdStepFn"
              />
              <img
                src="../../../assets/images/personalSign/tg_nor_btn.png"
                @click="jumpOutFn"
              />
            </div>
          </div>
          <img
            class="fourStepImg"
            src="../../../assets/images/personalSign/sxqs_img.png"
          />
        </div>
      </div>
      <div class="fiveStep" v-show="step == 4">
        <div class="thirdStepBoxCon">
          <div class="fristSetpBox">
            <div>
              <img
                src="../../../assets/images/personalSign/kown_nor_btn.png"
                @click="jumpOutFn"
              />
            </div>
          </div>
          <div class="thirdStepBox">
            <div class="fiveTableBob">
              <sort-table
                :powerId="contarctOwner.powerId"
                @delete="deleteTableItem"
                @addOtherSignPerson="addOtherSignPerson"
                :data="detail.signatoryList"
                :paymentTypeVlaue="paymentTypeVlaue"
                class="tableSign"
              ></sort-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :visible="isHaveCreate"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      class="mealBox"
    >
      <div class="signDialog" slot="dialog">
        <div class="mealTop">
          <p>该账号无权限执行此操作，请联系管理员处理</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center">
          <div class="button buttonActive cursorPointer" @click="closeCreate">
            确定
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Breadcrumb from "../../../components/common/Breadcrumb.vue";
import sortTable from "./components/signContract/sortTable.vue";
import slide from "./components/signContract/slide.vue";
import signForm from "./components/signContract/signForm.vue";
import information from "./components/signContract/information.vue";
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
import { mapGetters, mapMutations, mapState } from "vuex";
import annex from "./components/sign/annex.vue";
export default {
  data() {
    let validatePowerId = (rule, value, callback) => {
      if (this.contarctOwner.isOwner == "2" && !value) {
        callback(new Error("请选择代理人"));
      } else {
        callback();
      }
    };
    return {
      step: 1,
      stepSQ: 1,
      startGuide: false,
      startGuiden: false,
      Paybalance: false,
      returnList: [],
      authentication: false,
      authDialogShow: false,
      noPowerDialogShow: false,
      returnPay: "",
      scrollLong: 0,
      scrollTop: 0,
      money: "",
      balance: 0,
      num: 0, //上传文件个数
      totalValue: 0,
      remainValue: 0,
      searchContractName: "",
      //是否正在提交
      isSubmiting: false,
      radio: "1", //支付方式
      payNo: "", //订单号,
      wechatresultImg: "",
      detail: {},
      trueState: false,
      contarctOwner: {
        isOwner: "1",
        powerId: "",
      },
      signPersonList: [],
      contarctOwnerRule: {
        powerId: [{ validator: validatePowerId, trigger: "change" }],
      },
      // 是否超过5个未支付的合同
      isOverFreeContract: false,
      //未支付的合同数，
      noPayContractConout: 0,
      // 编辑时的附件列表
      annexFileList: [],
      userInfoResult: {},
      curId: "",
      paymentTypeVlaue: "1",
      fqTemplateList: [], //赋强合同列表
      fileVariableInfo: [], //重新发起赋强合同模板信息
      //验证权限
      isHaveCreate: false,
    };
  },
  components: {
    Breadcrumb,
    slide,
    sortTable,
    signForm,
    Dialog,
    annex,
    information,
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    ...mapState(["currentInfo"]),
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
  },
  mounted() {
    $(".signContainer")[0].addEventListener("scroll", this.handleScroll);
    this.judgePowerWithCreateCon().then((flag) => {
      if (flag == "Y") {
        this.createSign();
        if (this.$route.query.id) {
          this.getEditInfo();
          this.getFqContractTemplate();
        } else {
          this.getAgentOtherList();
        }
      }
    });
  },
  created() {
    this.contaractNum();
    this.keyupSubmit();
    this.getFqContractTemplate();
    this.createSign();
    const step =
      this.$store.getters.getUserInfo.pageGuideProcess["发起签约_赋强"];
    if (step) {
      if (step == 1) {
        this.secondStepSQFn();
      }
      if (step == 2) {
        this.thirdStepSQFn();
      }
    } else if (step == 0) {
      this.startGuideFn();
    }
  },
  methods: {
    //关闭提示弹框
    closeCreate() {
      this.$router.go(-1);
      this.isHaveCreate = false;
    },
    //验证权限
    createSign() {
      if (this.getUserInfo.person.userId != this.getUserInfo.currentUserId) {
        BaseApi.createRpcToken("/user/v2/getUserPermission", {}, "post")
          .then((value) => {
            if (value.code == 200) {
              if (
                !value.datas.permissionList.filter(
                  (item) => item.code == "SIGN_ADD"
                ).length
              ) {
                this.isHaveCreate = true;
              } else {
                this.isHaveCreate = false;
              }
            }
          })
          .catch(function (e) {
            errorLog(e);
          });
        // this.isHaveCreate=true;
      } else {
        this.isHaveCreate = false;
      }
    },
    handleScroll() {
      this.scrollTop = $(".signContainer")[0].scrollTop;
    },
    //查询赋强合同模板列表
    getFqContractTemplate() {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/fqContract/getFqContractTemplate").then(
        (data) => {
          if (data.code == 200) {
            this.$store.commit("showLoading", false);
            this.fqTemplateList = data.datas.fqTemplateList;
          }
        },
        (err) => {}
      );
    },
    //非授权合同操作指引
    firstStepFn() {
      this.step = 2;
      $(".signContainer").scrollTop(this.scrollLong);
      $(".thirdStepBoxCon")
        .eq(0)
        .css(
          "top",
          Number($(".thirdStepBoxCon").eq(0).css("top").split("px")[0]) -
            this.scrollLong
        );
    },
    secondStepFn() {
      this.step = 3;
      $(".thirdStepBoxCon")
        .eq(1)
        .css(
          "top",
          Number($(".thirdStepBoxCon").eq(1).css("top").split("px")[0]) -
            this.scrollLong
        );
    },
    thirdStepFn() {
      this.step = 4;
      $(".thirdStepBoxCon")
        .eq(2)
        .css(
          "top",
          Number($(".thirdStepBoxCon").eq(2).css("top").split("px")[0]) -
            this.scrollLong
        );
    },
    aaaa(data) {
      console.log(data);
    },
    //授权合同操作指引
    firstStepSQFn() {
      this.stepSQ = 2;
      if (this.scrollLong < 200) {
        $(".signContainer").scrollTop(this.scrollLong);
        $(".thirdStepBoxCon")
          .eq(0)
          .css(
            "top",
            Number($(".thirdStepBoxCon").eq(0).css("top").split("px")[0]) -
              this.scrollLong
          );
      } else {
        $(".signContainer").scrollTop(200);
        $(".thirdStepBoxCon")
          .eq(0)
          .css(
            "top",
            Number($(".thirdStepBoxCon").eq(0).css("top").split("px")[0]) - 200
          );
      }
    },
    secondStepSQFn() {
      this.stepSQ = 2;
      $(".signContainer").scrollTop(200);
      this.savePageGuideProcess(2);

      document.querySelector(".thirdStepBoxCon").style.top =
        document.querySelector(".sign_form").getBoundingClientRect().top + "px";
      // $(".thirdStepBoxCon")
      //   .eq(1)
      //   .css(
      //     "top",
      //     Number(
      //       $(".thirdStepBoxCon")
      //         .eq(1)
      //         .css("top")
      //         .split("px")[0]
      //     ) - this.scrollLong
      //   );
      // if(this.scrollLong<200){
      // }else{
      //   $('.thirdStepBoxCon').eq(1).css('top',Number($('.thirdStepBoxCon').eq(1).css('top').split('px')[0])-200)
      // }
    },
    thirdStepSQFn() {
      this.stepSQ = 3;
      $(".signContainer").scrollTop(550);
      this.savePageGuideProcess(3);
      document.querySelector(".thirdStepBoxCon1").style.top =
        document.querySelector(".information").getBoundingClientRect().top +
        "px";
      // $(".thirdStepBoxCon")
      //   .eq(2)
      //   .css(
      //     "top",
      //     Number(
      //       $(".thirdStepBoxCon")
      //         .eq(2)
      //         .css("top")
      //         .split("px")[0]
      //     ) - this.scrollLong
      //   );
    },
    fourStepSQFn() {
      this.stepSQ = 5;
      $(".thirdStepBoxCon")
        .eq(3)
        .css(
          "top",
          Number($(".thirdStepBoxCon").eq(3).css("top").split("px")[0]) -
            this.scrollLong
        );
    },
    jumpOutFn() {
      this.startGuide = false;
      this.startGuiden = false;
    },
    startGuideFn() {
      // if (this.signPersonList.length > 0) {
      this.startGuide = true;
      this.stepSQ = 1;
      // } else {
      // this.startGuiden = true;
      // this.step = 1;
      // }
      this.scrollLong =
        $(".signContainer")[0].scrollHeight - $(".signContainer").outerHeight();
      setTimeout(() => {
        $(".fristSetpCon").css(
          "top",
          Number($(".fristSetpCon").css("top").split("px")[0]) - this.scrollTop
        );
      }, 1);
      this.savePageGuideProcess(1);
    },
    // 获取用户信息
    getUserInfos() {
      return BaseApi.createRpcToken("/user/v2/getUserInfo");
    },
    //获取未支付的合同数
    getNoPayContractConout() {
      return BaseApi.createRpcToken("/contract/countNotPaid");
    },
    // 判断用户是否有权限发起合同
    async judgePowerWithCreateCon() {
      try {
        if (!this.$route.query.id) {
          // console.log(this.getUserInfo)
          if (this.getUserInfo.hasOwnProperty("currentUserId")) {
            let data = this.getUserInfo;
            sessionStorage.setItem("userInfo", JSON.stringify(data));
            this.setUserInfo(data);
            if (data.currentUserId == data.person.userId) {
              this.userInfoResult = data.person;
            } else {
              this.userInfoResult = data.enterpriseList[0];
            }
            if (!data.person || data.person.authenticationStatus != 2) {
              // 未实名显示弹窗禁止操作
              this.authDialogShow = true;
              return Promise.resolve("N");
            }
            if (this.currentInfo.realNameType == 2) {
              if (!data.person || data.person.authenticationStatus != 2) {
                // 未实名显示弹窗禁止操作
                this.authDialogShow = true;
                return Promise.resolve("N");
              } else {
                if (this.currentInfo.authenticationStatus != 2) {
                  this.authDialogShow = true;
                  return Promise.resolve("N");
                }
              }
            }
          } else {
            let data = await this.getUserInfos();
            sessionStorage.setItem("userInfo", JSON.stringify(data.datas));
            this.setUserInfo(data.datas);
            if (data.datas.currentUserId == data.datas.person.userId) {
              this.userInfoResult = data.datas.person;
            } else {
              this.userInfoResult = data.datas.enterpriseList[0];
            }
            if (
              !data.datas.person ||
              data.datas.person.authenticationStatus != 2
            ) {
              // 未实名显示弹窗禁止操作
              this.authDialogShow = true;
              return Promise.resolve("N");
            }
            if (this.currentInfo.realNameType == 2) {
              if (
                !data.datas.person ||
                data.datas.person.authenticationStatus != 2
              ) {
                // 未实名显示弹窗禁止操作
                this.authDialogShow = true;
                return Promise.resolve("N");
              } else {
                if (this.currentInfo.authenticationStatus != 2) {
                  this.authDialogShow = true;
                  return Promise.resolve("N");
                }
              }
            }
          }

          //  判断未支付的合同个数 大于5禁止新建
          let noPayContractInfo = await this.getNoPayContractConout();
          this.noPayContractConout =
            (noPayContractInfo.datas &&
              noPayContractInfo.datas.count &&
              noPayContractInfo.datas.count - 0) ||
            0;
          if (this.noPayContractConout >= 5) {
            this.isOverFreeContract = true;
            return Promise.resolve("N");
          }
          return Promise.resolve("Y");
        } else {
          return Promise.resolve("Y");
        }
      } catch (e) {}
    },

    // 得到编辑信息
    async getEditInfo() {
      let signPersonInfo = await this.getAgentOtherList(true);
      let signPersonList = signPersonInfo.datas.list;
      this.signPersonList = signPersonList;
      BaseApi.createRpcToken("/contract/find", {
        id: this.$route.query.id,
      }).then(
        (data) => {
          try {
            let detail = data.datas.contract;
            console.log(data.datas.fileVariableInfo);

            this.fileVariableInfo = data.datas.fileVariableInfo;
            this.$bus.on("curFqTemplate", (value) => {
              console.log(value);
            });
            // console.log(this.getUserInfo)
            if (
              detail.info.userId !== this.currentInfo.userId ||
              detail.info.createUserId !== this.getUserInfo.person.userId
            ) {
              this.contarctOwner.isOwner = "2";
              let isHavePower = false;
              for (let i = 0; i < signPersonList.length; i++) {
                if (signPersonList[i].value == detail.info.userId) {
                  this.signPersonList = signPersonList;
                  isHavePower = true;
                  this.$nextTick(() => {
                    this.contarctOwner.powerId = detail.info.userId;
                  });
                  break;
                }
              }
              if (!isHavePower) {
                //需要显示发送
                this.noPowerDialogShow = true;
              }
            }
            // this.annexFileList = detail.attachmentList;
            this.contractId = this.$route.query.id;
            this.$refs.slide.setData(detail.fileList);
            this.$refs.forms.setData(detail.info);
            detail.signatoryList.forEach((item) => {
              if (item.type == 2) {
                item.mail = "";
              }
            });
            this.$refs.table.setData(detail.signatoryList);
          } catch (e) {}
        },
        (err) => {}
      );
    },
    keyupSubmit() {
      document.onkeydown = (e) => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          // this.handlerNext(); // 6-6 关闭回车事件
        }
      };
    },
    contaractNum(data) {
      this.num = data;
    },
    goList() {
      this.$router.push("/personal/sign/home");
    },
    contaractNum(data) {
      this.num = data;
    },
    getAgentOtherList(isAsync) {
      if (!isAsync) {
        BaseApi.createRpcToken("/agent/getPrincipal").then(
          (data) => {
            this.signPersonList = data.datas.list;
          },
          (err) => {}
        );
      } else {
        return BaseApi.createRpcToken("/agent/getPrincipal");
      }
    },
    //选择支付方式
    paymentType(data) {
      this.paymentTypeVlaue = data;
    },
    powerIdChange(value = localStorage.userId) {
      this.$refs.table.restList(value);
    },
    isOwnerChange() {
      if (this.contarctOwner.isOwner == 1) {
        this.contarctOwner.powerId = "";
        this.powerIdChange();
      }
    },
    ...mapMutations(["setUserInfo"]),
    goAuth() {
      //去认证页面
      let exuserid = sessionStorage.getItem("userInfo")
        ? JSON.parse(sessionStorage.getItem("userInfo"))
        : "";
      // localStorage.getItem("curID")==exuserid.person.userId
      if (exuserid.person.authenticationStatus != 2) {
        this.$router.push({
          path: "/personal/users/PersonalCertificate",
          query: {
            userId: exuserid.person.userId,
          },
        });
      } else {
        this.$router.push({
          path: "/personal/users/enterprise",
          query: {
            step: this.step,
            exId: exuserid.enterpriseList.length
              ? exuserid.enterpriseList[0].userId
              : "",
          },
        });
      }
      this.authDialogShow = false;
    },
    closeDialog(flag) {
      this[flag] = false;
    },
    toModelContract() {
      this.$router.push("/personal/sign/record");
    },
    async handlerNext() {
      let that = this;
      this.$refs.contarctOwner.validate();
      let slideData = this.$refs.slide.save();
      let slideData_contractList = this.$refs.slide.contractListSubmit();
      if (
        slideData_contractList.data.length == 0 &&
        slideData.data.length == 0
      ) {
        this.$message.error("请上传合同文件");
        return;
      }
      //付费方式
      let paymentType = this.$refs.forms.paymentTypeChange();
      if (this.currentInfo.success) {
        let formData = await this.$refs.forms.save();
        let tableData = this.$refs.table.save();
        if (!tableData.valid) {
          this.$message.error(tableData.validMessage);
          return;
        } else if (!formData.valid) {
          return;
        } else if (
          this.contarctOwner.isOwner == 2 &&
          !this.contarctOwner.powerId
        ) {
          return;
        } else if (tableData.isValyes == 0 && paymentType == 2) {
          this.$message.error("签约支付费用少于该合同费用");
          return;
        } else if (tableData.isValyes == 1 && paymentType == 2) {
          this.$message.error("签约支付费用超出该合同费用");
          return;
        } else if (tableData.data.length < 1) {
          this.$message.error("请至少有一位签署方");
          return;
        }
        // else if(tableData.data.length > 2){
        // this.$message.error("仅支持两方签署");
        // return; }
        else {
          let inforMation = await this.$refs.inforform.save();
          // let slideData = this.$refs.slide.save();
          // let slideData_contractList = this.$refs.slide.contractListSubmit();
          if (!slideData_contractList.data.length) {
            this.$message.error("请上传合同文件");
            return;
          }
          if (inforMation.valid) {
            this.$store.commit("showLoading", true);
            let inforMationData = {
              ...inforMation.data,
              templateId: slideData.data.filePath
                ? slideData.data.templateId
                : undefined,
              fileId: slideData_contractList.data[0].id,
            };
            if (inforMationData.documentNum) { // 乙方身份证号码 将小写x替换为大写X
              console.log(inforMationData, 'inforMationData')
              inforMationData.documentNum = inforMationData.documentNum.replace(/x/g, 'X')
            }
            BaseApi.createRpcToken(
              "/fqContract/generateFileByTemplateAndUploadContract",
              inforMationData,
              "get"
            ).then(
              async (res) => {
                if (res.code == 200 && res.datas.fileInfo.id) {
                  const obj = {};
                  if (process.env.VUE_APP_OFFLINESIGN_FLAG) {
                    const offlineSignArr = this.$refs.table.signContractTipData;
                    offlineSignArr.forEach(
                      (ele) => (obj[ele.signatoryId] = ele.offlineSign)
                    );
                  }
                  let params = Object.assign({}, formData.data);
                  params.signatoryIds = tableData.data.join(",");
                  params.fileIds = res.datas.fileInfo.id;
                  params.orderType = tableData.orderType;
                  params.type = 2;
                  params.signatoryAmount = JSON.stringify(
                    tableData.signatoryAmount
                  );
                  params.offlineFlagMap = process.env.VUE_APP_OFFLINESIGN_FLAG
                    ? JSON.stringify(obj)
                    : "";
                  params.payMode = paymentType;
                  if (!this.isSubmiting) {
                    this.isSubmiting = true;
                    if (this.contractId) {
                      params.id = this.contractId;
                    }
                    // 如果选择代理人就参数需要增加 userid
                    if (this.contarctOwner.powerId) {
                      params.contractUserId = this.contarctOwner.powerId;
                    }
                    if (this.userInfo.signWhetherPayment === 2) {
                      params.signWhetherPayment = this.userInfo.signWhetherPayment;
                    }
                    console.log(params, "params");
                    BaseApi.createRpcToken(
                      "/contract/add",
                      params,
                      "post"
                    ).then(
                      (data) => {
                        this.$store.commit("showLoading", false);
                        if (data.datas == null && paymentType == "2") {
                          this.$message.error(
                            "添加的签署方存在未注册用户，请添加已注册的签署方！"
                          );
                          this.isSubmiting = false;
                          return;
                        }
                        this.contractId = data.datas.id;
                        

                        // 无需付费
                        if (this.userInfo.signWhetherPayment === 2) {
                          that.$router.push({
                            path: `/personal/sign/complete?id=${that.contractId}&flag=startSign&type=2`,
                          });
                          return;
                        }

                        //发起方付费
                        if (paymentType == 1) {
                          // 判断是否已经支付过
                          this.getContractInfo().then(
                            async function (data) {
                              if (data.datas.info.payStatus == 0) {
                                //去支付
                                that.$router.push({
                                  path: "/personal/payment",
                                  query: {
                                    id: that.contractId,
                                    flag: "startSign",
                                    type: 2,
                                  },
                                });
                              } else {
                                that.$router.push({
                                  path: `/personal/sign/complete?id=${that.contractId}&flag=startSign&type=2`,
                                });
                              }
                              that.isSubmiting = false;
                            },
                            () => {
                              that.isSubmiting = false;
                            }
                          );
                        }
                        //各签署方付费
                        else if (paymentType == 2) {
                          that.$router.push({
                            path: `/personal/sign/complete?id=${that.contractId}&flag=startSign&type=2`,
                          });
                        }
                      },
                      () => {
                        this.$store.commit("showLoading", false);
                        this.isSubmiting = false;
                      }
                    );
                  }
                }
              },
              () => {
                this.isSubmiting = false;
              }
            );
          }
        }
      } else {
        this.authDialogShow = true;
      }
      //     }else{
      //       this.$message.error(tableData.validMessage);
      //       this.isSubmiting = false;
      //       return;
      //     }
      //   },() => {
      //       this.isSubmiting = false;
      //     }
      //   )
    },
    deleteTableItem(row) {},
    deleteContract(data) {
      this.deleteDialogShow = true;
    },
    reNameContract(data) {
      this.renameDialogShow = true;
    },
    addOtherSignPerson() {
      this.signListShow = true;
    },
    toIndex() {
      this.$router.push("/personal/sign/home");
    },
    getContractInfo() {
      return BaseApi.createRpcToken(
        "/contract/info",
        { id: this.contractId },
        "post"
      );
    },
    // 记录用户引导步骤
    savePageGuideProcess(num) {
      // const data = JSON.stringify()
      // console.log(data);
      BaseApi.createRpcToken(
        "/user/v2/savePageGuideProcess",
        {
          pageName: "发起签约_赋强",
          process: num + "",
        },
        "post",
        false,
        false,
        false
      );
    },
    // 上传文件模板
  },
  watch: {
    "getUserInfo.currentUserId"(data) {
      this.judgePowerWithCreateCon();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signContainer {
  .el-radio__label,
  .el-radio__input.is-checked + .el-radio__label {
    font-size: 12px;
    color: #969696;
    padding-left: 10px;
  }
  .is-focus .el-radio__input .el-radio__inner {
    border: 1px solid #dcdfe6;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #e88078;
    background: #e88078;
  }
  .el-form-item__label {
    font-size: 12px;
    color: #969696;
  }
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  .signoHeader {
    padding: 20px 20px 0 20px;
    .authentication {
      height: 30px;
      line-height: 30px;
      background: #fbeceb;
      padding-left: 19px;
      .authBtn {
        border: 1px solid #e88078;
        border-radius: 3px;
        display: inline-block;
        padding: 3px 15px;
        line-height: 12px;
        margin-left: 20px;
      }
    }
    .contract {
      overflow: hidden;
      width: 100%;
      padding-top: 30px;
      position: relative;
      .OperationGuide {
        position: absolute;
        right: 0;
        font-size: 14px;
        color: #0082ff;
        cursor: pointer;
      }
      .contarctOwner {
        // border-top: 1px solid #dcdcdc;
        clear: both;
        padding: 20px 0 10px 0;
      }
      .title {
        float: left;
        height: 200px;
        width: 70px;
        line-height: 200px;
        font-size: 14px;
        color: #969696;
      }
      .signAnnex {
        display: flex;
        width: 100%;
        height: auto;
      }
      .annexTitle {
        width: 147px;
        font-size: 14px;
        color: #969696;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .slideCustomer {
        float: left;
        height: 200px;
        width: calc(100% - 70px);
        margin-bottom: 40px;
      }
      .swiperSlidecustomerAdd {
        float: left;
        margin: 0 10px;
        width: 160px;
        height: 200px;
        position: relative;
        cursor: pointer;
        .content {
          &:hover {
            background-color: rgb(240, 240, 240);
          }
          width: 100%;
          height: 146px;
          box-sizing: border-box;
          padding: 10px;
          background-color: rgb(248, 248, 248);
          display: flex;
          justify-content: center;
          align-items: center;
          .selectDscp {
            font-size: 14px;
            color: #646464;
            margin-top: 14px;
          }
        }
        .slectHeight {
          height: 200px;
          flex-direction: column;
        }
        .cover {
          display: none;
        }
        &:hover {
          .cover {
            position: absolute;
            display: block;
            width: 100%;
            height: 146px;
            left: 0;
            top: 0;
            z-index: 1;
            img {
              height: 146px;
              width: 160px;
              display: block;
            }
          }
        }
        .coverDscp {
          position: absolute;
          z-index: 2;
          width: 160px;
          box-sizing: border-box;
          height: 55px;
          line-height: 55px;
          bottom: 0;
          border: 1px solid rgb(240, 240, 240);
          background-color: white;
          font-size: 14px;
          color: #646464;
          text-align: center;
        }
      }
    }
  }
  .paddingBox {
    width: 100%;
    height: 10px;
    background: #eaedf1;
  }
  .signContent {
    width: 100%;
    // height: calc(100% - 416px);
    box-sizing: border-box;
    padding: 30px 20px 49px 20px;
    .stepDscp {
      height: 22px;
      font-size: 14px;
      color: #505050;
      font-weight: 600;
      border-bottom: 1px solid #dcdcdc;
      margin-bottom: 20px;
    }
    .routeChangeBox {
      text-align: center;
      height: 34px;
      .routeChangeButton {
        display: inline-block;
        width: 160px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 12px;
        border-radius: 5px;
        color: #646464;
        border: 1px solid #c8c8c8;
        &:hover {
          background-color: #a5303d;
          border: 1px solid #a5303d;
          color: white;
        }
      }
      & > .routeChangeButton:first-child {
        margin-right: 20px;
      }
    }
  }
  .signDialog {
    height: 200px;
    width: 400px;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    .authDscp {
      font-size: 14px;
      color: #646464;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      padding-top: 20px;
    }
    .withInput {
      width: 100%;
      text-align: left;
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .signDialogs {
    height: 200px;
    width: 400px;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    .withInput {
      width: 100%;
      text-align: left;
      p {
        margin-bottom: 10px;
      }
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .mealBox {
    .mealCon {
      height: 200px;
      .mealTop {
        height: 138px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          font-size: 14px;
          color: #646464;
          letter-spacing: 0;
          text-align: center;
          line-height: 22px;
        }
      }
      .mealBottom {
        display: flex;
        justify-content: center;
        span {
          display: inline-block;
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #c8c8c8;
          font-size: 12px;
          color: #646464;
          cursor: pointer;
        }
        span:nth-child(2) {
          color: #fff;
          background: #d81212;
          border-color: #d81212;
          margin-left: 40px;
        }
      }
    }
    .balanceCon {
      height: 200px;
      .mealTop {
        height: 138px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h1 {
          font-size: 36px;
          color: #e72525;
          line-height: 36px;
          font-weight: normal;
        }
        p:nth-child(2) {
          font-size: 14px;
          color: #919191;
          line-height: 14px;
          margin-top: 6px;
          margin-bottom: 10px;
        }
        p:nth-child(3) {
          font-size: 14px;
          color: #919191;
        }
      }
      .mealBottom {
        display: flex;
        justify-content: center;
        span {
          display: inline-block;
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #c8c8c8;
          font-size: 12px;
          color: #646464;
          cursor: pointer;
        }
        span:nth-child(2) {
          color: #fff;
          background: #d81212;
          border-color: #d81212;
          margin-left: 40px;
        }
      }
    }
  }
  .guideBoxo {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(100, 100, 100, 0.5);
    z-index: 999999999999;
    .fristSetp {
      width: 100%;
      height: 100%;
      position: relative;
      // display: none;
      .fristSetpCon {
        position: absolute;
        left: 350px;
        top: 145px;
        .fristSetpBox {
          width: 490px;
          height: 222px;
          // background: url("../../../assets/images/personalSign/word_1th_img.png") no-repeat;
          background-size: cover;
          margin-top: -208px;
          margin-left: 542px;
          .signHome_j {
            width: 340px;
            height: 11px;
            position: absolute;
            top: 100px;
            left: 183px;
          }
          .guodance_sign_bg {
            padding: 20px;
            width: 439px;
            background-color: #ffffff;
            min-height: 106px;
            // background: url("../../assets/images/guidance/signHome_mask.png");
            background-position: center center;
            background-size: 100% 100%;
            .title {
              display: flex;
              justify-content: space-between;
              .jumpOutFn {
                color: #979797;
                font-size: 13px;
                cursor: pointer;
              }
            }
            h3 {
              font-size: 20px;
              color: #000000;
              line-height: 26px;
              margin-bottom: 10px;
            }
            .text_list {
              font-size: 14px;
              color: #4f4f4f;
              line-height: 24px;
              height: 30px;
              b {
                width: 6px;
                height: 6px;
                background: #cc0404;
                border-radius: 50%;
                display: inline-block;
                float: left;
                margin-top: 8px;
                margin-right: 8px;
              }
            }
            .guodance_sign_bottom {
              width: 100%;
              margin-top: 30px;
              display: flex;
              height: 36px;
              justify-content: space-between;
              align-items: center;
              p {
                font-size: 14px;
                color: #b2afaf;
              }
              button {
                width: 96px;
                height: 36px;
                background: #d01f1f;
                border-color: #d01f1f;
                border-radius: 4px;
                color: #fff;
                font-size: 18px;
                cursor: pointer;
              }
            }
          }
          // div {
          //   position: relative;
          //   width: 100%;
          //   height: 100%;
          //   img:nth-child(1) {
          //     position: absolute;
          //     bottom: 20px;
          //     left: 80px;
          //   }
          //   img:nth-child(2) {
          //     position: absolute;
          //     bottom: 27px;
          //     left: 230px;
          //   }
          // }
        }
      }
    }
    .secondSetp {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        position: absolute;
        width: 100%;
        top: 375px;
        left: 10px;
        .thirdStepBox {
          background-color: #fff;
          width: calc(100% - 30px);
          padding: 20px 55px;
          box-sizing: border-box;
        }
        .fristSetpBox {
          margin-top: 20px;
          margin-left: 200px;
          width: 348px;
          height: 222px;
          // background: url("../../../assets/images/personalSign/worf_sq_2th_img.png")
          // no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img:nth-child(1) {
              position: absolute;
              bottom: 20px;
              left: 80px;
            }
            img:nth-child(2) {
              position: absolute;
              bottom: 27px;
              left: 230px;
            }
          }
        }
      }
    }
    .thirdStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        width: calc(100% - 40px);
        position: absolute;
        // top: 35vh;
        left: 2vh;
        .thirdStepBox {
          // background-color: #fff;
          width: 100%;
          padding: 20px 30px 20px 0;
          box-sizing: border-box;
          img {
            transform: scale(0.9);
            position: relative;
            left: -43px;
          }
        }
        .fristSetpBox {
          width: 490px;
          height: 222px;
          margin-top: -222px;
          margin-left: 684px;
          /*  background: url("../../../assets/images/personalSign/word_sq_3th_img.png")
            no-repeat; */
          background-size: 100% 100%;
          .signHome_j {
            width: 315px;
            height: 11px;
            position: absolute;
            top: 141px;
            left: 482px;
            z-index: -1;
          }
          .guodance_sign_bg {
            background-color: #ffffff;
            padding: 20px;
            width: 439px;
            min-height: 106px;
            // background: url("../../assets/images/guidance/signHome_mask.png");
            background-position: center center;
            background-size: 100% 100%;
            .title {
              display: flex;
              justify-content: space-between;
              .jumpOutFn {
                color: #979797;
                font-size: 13px;
                cursor: pointer;
              }
            }
            h3 {
              font-size: 20px;
              color: #000000;
              line-height: 26px;
              margin-bottom: 10px;
            }
            .text_list {
              font-size: 14px;
              color: #4f4f4f;
              line-height: 24px;
              height: 30px;
              b {
                width: 6px;
                height: 6px;
                background: #cc0404;
                border-radius: 50%;
                display: inline-block;
                float: left;
                margin-top: 8px;
                margin-right: 8px;
              }
            }
            .guodance_sign_bottom {
              width: 100%;
              margin-top: 30px;
              display: flex;
              height: 36px;
              justify-content: space-between;
              align-items: center;
              p {
                font-size: 14px;
                color: #b2afaf;
              }
              button {
                width: 96px;
                height: 36px;
                background: #d01f1f;
                border-color: #d01f1f;
                border-radius: 4px;
                color: #fff;
                font-size: 18px;
                cursor: pointer;
              }
            }
          }
          // div {
          //   position: relative;
          //   width: 100%;
          //   height: 100%;
          //   img:nth-child(1) {
          //     position: absolute;
          //     bottom: 20px;
          //     left: 80px;
          //   }
          //   img:nth-child(2) {
          //     position: absolute;
          //     bottom: 27px;
          //     left: 230px;
          //   }
          // }
        }
      }
    }
    .fourStep1 {
      min-width: 1200px;
      // height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon1 {
        position: absolute;
        // top: 51vh !important;
        left: 14px;
        .fourStepImg {
          margin-top: 145px;
          width: 458px;
          height: 60px;
        }
        .fristSetpBox {
          width: 476px;
          height: 200px;
          margin-left: 684px;
          position: absolute;
          top: -65px;
          background-color: transparent;

          /* background: url("../../../assets/images/personalSign/word_sq_4th_img.png")
            no-repeat; */
          background-size: 100% 100%;
          .signHome_j {
            width: 280px;
            height: 11px;
            position: absolute;
            top: 61px;
            left: -222px;
          }
          .guodance_sign_bg {
            padding: 20px;
            width: 439px;
            background-color: #fff;
            min-height: 106px;
            // background: url("../../assets/images/guidance/signHome_mask.png");
            background-position: center center;
            background-size: 100% 100%;
            .title {
              display: flex;
              justify-content: space-between;
              .jumpOutFn {
                color: #979797;
                font-size: 13px;
                cursor: pointer;
              }
            }
            h3 {
              font-size: 20px;
              color: #000000;
              line-height: 26px;
              margin-bottom: 10px;
            }
            .text_list {
              font-size: 14px;
              color: #4f4f4f;
              line-height: 24px;
              height: 50px;
              b {
                width: 6px;
                height: 6px;
                background: #cc0404;
                border-radius: 50%;
                display: inline-block;
                float: left;
                margin-top: 8px;
                margin-right: 8px;
              }
            }
            .guodance_sign_bottom {
              width: 100%;
              // margin-top: 30px;
              display: flex;
              height: 36px;
              justify-content: space-between;
              align-items: center;
              p {
                font-size: 14px;
                color: #b2afaf;
              }
              button {
                width: 96px;
                height: 36px;
                background: #d01f1f;
                border-color: #d01f1f;
                border-radius: 4px;
                color: #fff;
                font-size: 18px;
                cursor: pointer;
              }
            }
          }
          // div {
          //   position: relative;
          //   width: 100%;
          //   height: 100%;
          //   img:nth-child(1) {
          //     position: absolute;
          //     bottom: 20px;
          //     left: 136px;
          //   }
          //   img:nth-child(2) {
          //     position: absolute;
          //     bottom: 27px;
          //     left: 275px;
          //   }
          // }
        }
        .thirdStepBox {
          position: absolute;
          top: -171px;
        }
      }
    }
    .fiveStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        width: calc(100% - 40px);
        position: absolute;
        top: 471px;
        left: 20px;
        .thirdStepBox {
          background-color: #fff;
          box-sizing: border-box;
          .fiveTableBob {
            width: 100%;
            height: 178px;
            padding-top: 20px;
            .tableSign {
              position: relative;
            }
            .tableSign:after {
              content: "";
              position: absolute;
              top: 10px;
              width: 200px;
              height: 30px;
              background-color: #fff;
            }
            .tableSign:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1111;
            }
          }
        }
        .fristSetpBox {
          width: 348px;
          height: 222px;
          margin-left: 300px;
          margin-bottom: 20px;
          // background: url("../../../assets/images/personalSign/word_sq_5th_img.png")
          //   no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img {
              position: absolute;
              bottom: 76px;
              left: 115px;
            }
          }
        }
      }
    }
  }
  .guideBoxn {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(100, 100, 100, 0.5);
    z-index: 999999999999;
    .fristSetp {
      width: 100%;
      height: 100%;
      position: relative;
      // display: none;
      .fristSetpCon {
        position: absolute;
        left: 347px;
        top: 145px;
        .fristSetpBox {
          width: 348px;
          height: 222px;
          // background: url("../../../assets/images/personalSign/word_1th_img.png")
          //   no-repeat;
          background-size: cover;
          margin-top: 20px;
          margin-left: 107px;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img:nth-child(1) {
              position: absolute;
              bottom: 20px;
              left: 80px;
            }
            img:nth-child(2) {
              position: absolute;
              bottom: 27px;
              left: 230px;
            }
          }
        }
      }
    }
    .thirdStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        width: calc(100% - 40px);
        position: absolute;
        top: 445px;
        left: 20px;
        .thirdStepBox {
          background-color: #fff;
          width: 100%;
          padding: 20px 30px;
          box-sizing: border-box;
          .thirdStepBoxImg {
            width: 800px !important;
          }
        }
        .fristSetpBox {
          width: 348px;
          height: 222px;
          margin-top: 20px;
          margin-left: 300px;
          // background: url("../../../assets/images/personalSign/worf_2th_img.png")
          //   no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img:nth-child(1) {
              position: absolute;
              bottom: 20px;
              left: 80px;
            }
            img:nth-child(2) {
              position: absolute;
              bottom: 27px;
              left: 230px;
            }
          }
        }
      }
    }
    .fourStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        position: absolute;
        top: 510px;
        left: 20px;
        .fourStepImg {
          background-color: #fff;
        }
        .fristSetpBox {
          width: 400px;
          height: 170px;
          margin-left: 200px;
          // background: url("../../../assets/images/personalSign/word_3th_img.png")
          //   no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img:nth-child(1) {
              position: absolute;
              bottom: 20px;
              left: 136px;
            }
            img:nth-child(2) {
              position: absolute;
              bottom: 27px;
              left: 275px;
            }
          }
        }
      }
    }
    .fiveStep {
      min-width: 1200px;
      height: 100%;
      position: relative;
      margin-left: 180px;
      .thirdStepBoxCon {
        width: calc(100% - 40px);
        position: absolute;
        top: 392px;
        left: 20px;
        .thirdStepBox {
          background-color: #fff;
          box-sizing: border-box;
          .fiveTableBob {
            width: 100%;
            height: 178px;
            padding-top: 20px;
            .tableSign {
              position: relative;
            }
            .tableSign:after {
              content: "";
              position: absolute;
              top: 10px;
              width: 200px;
              height: 30px;
              background-color: #fff;
            }
            .tableSign:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1111;
            }
          }
        }
        .fristSetpBox {
          width: 348px;
          height: 222px;
          margin-left: 300px;
          margin-bottom: 20px;
          // background: url("../../../assets/images/personalSign/word_4th_img.png")
          //   no-repeat;
          background-size: 100% 100%;
          div {
            position: relative;
            width: 100%;
            height: 100%;
            img {
              position: absolute;
              bottom: 76px;
              left: 115px;
            }
          }
        }
      }
    }
  }
}
</style>
